module.exports = __webpack_public_path__ + "static/media/coinlogo.f5ad9dd0.svg";